import React, { useState, useEffect } from "react"; // Import useEffect
import {
  FaWhatsapp,
  FaInstagram,
  FaYoutube,
  FaTelegram,
  FaFacebook,
  FaChevronDown, // Icon for collapsing
  FaChevronUp, // Icon for expanding
} from "react-icons/fa";
import axiosInstance from "../../utils/axiosInstance";


// Mapping for icons, colors, and the platform key used in the backend
const socialMediaMap = [
  { platform: "facebook", Icon: FaFacebook, color: "bg-blue-800", aria: "Facebook" },
  { platform: "telegram", Icon: FaTelegram, color: "bg-sky-500", aria: "Telegram" },
  { platform: "youtube", Icon: FaYoutube, color: "bg-red-600", aria: "YouTube" },
  { platform: "instagram", Icon: FaInstagram, color: "bg-pink-600", aria: "Instagram" },
  { platform: "whatsapp", Icon: FaWhatsapp, color: "bg-green-600", aria: "WhatsApp" },
];

export default function FloatingChat() {
  const [isVisible, setIsVisible] = useState(true);
  const [socialLinks, setSocialLinks] = useState(null); // State to hold fetched links
  const [isLoading, setIsLoading] = useState(true); // State for loading

  // Effect to fetch social links on component mount
  useEffect(() => {
  const fetchLinks = async () => {
    try {
        // Axios automatically handles the JSON parsing and returns the data object
        const response = await axiosInstance.get(`/social-links`);
        setSocialLinks(response.data); 
        
    } catch (error) {
        // Axios rejects the promise for 4xx and 5xx errors, or network errors.
        if (axiosInstance.isCancel(error)) {
             // Ignore cancel errors (if you were using cancellation)
             return;
        }
        console.error("Error fetching social links:", error.message);
        setSocialLinks({}); 

    } finally {
        setIsLoading(false);
    }
};

    fetchLinks();
  }, []);

  const toggleVisibility = () => {
    setIsVisible(!isVisible);
  };
  
  // Do not render anything if still loading or if no links are available
  if (isLoading || !socialLinks || Object.keys(socialLinks).length === 0) {
    return null;
  }

  return (
    <div className="fixed right-4 bottom-6 flex flex-col items-end gap-3 z-50">
      {/* Toggle Button - Size changed to w-12 h-12 */}
      <button
        onClick={toggleVisibility}
        className="w-12 h-12 flex items-center justify-center rounded-full bg-[#551756] shadow-lg text-white text-2xl"
        aria-label={isVisible ? "Collapse social links" : "Expand social links"}
      >
        {/* Change icon based on visibility state */}
        {isVisible ? <FaChevronDown /> : <FaChevronUp />}
      </button>

      {/* Conditionally render social media icons */}
      {isVisible && (
        <>
          {/* Map through the defined social media items */}
          {socialMediaMap.map(({ platform, Icon, color, aria }) => {
            const linkUrl = socialLinks[platform];
            
            // Render only if a link exists for this platform
            if (linkUrl) {
              return (
                <a 
                  key={platform}
                  href={linkUrl} 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  aria-label={aria}
                >
                  <div className={`w-12 h-12 flex items-center justify-center rounded-full shadow-lg text-white text-2xl ${color}`}>
                    <Icon />
                  </div>
                </a>
              );
            }
            return null; // Don't render if no link is found
          })}
        </>
      )}
    </div>
  );
}